import { useFetchData } from "../../../../hooks/useFetch";
import { AttendanceDailySession, AttendanceGridRow } from "../types/attendance";
import { ApiConfig, API_ATTENDANCE_ROUTER } from "../../../../services/api-config";
import { BasePaginateResponse } from "../../../../models/response/base-response";

// Mirror của hrm CHECK_IN_DAY_TYPE (check-in-status.response.ts) — 2 codebase tách biệt, không dùng
// chung package nên phải tự khai lại, đổi giá trị enum bên hrm PHẢI đổi khớp ở đây.
export enum CHECK_IN_DAY_TYPE {
    WORKING = 1,
    HOLIDAY = 2,
    DAY_OFF = 3,
    NOT_APPLICABLE = 4,
}

export interface CheckInStatus {
    attendance_mode: number;
    day_type: CHECK_IN_DAY_TYPE;
    should_show_button: boolean;
    label: string | null;
    schedule_name: string | null;
    start_time: string | null;
    end_time: string | null;
}

// Khớp CheckLocationScopeResponse bên hrm.
export interface CheckLocationScope {
    in_scope: boolean;
    distance_m: number;
    radius_m: number;
    branch_name: string;
}

export const AttendanceService = {
    // Kiểm tra vị trí TRƯỚC khi chấm công — để hỏi xác nhận nếu ngoài bán kính (BE vẫn chỉ cảnh báo,
    // không chặn — xem AttendanceRecordsService#getEmployeeCheckInScope bên hrm).
    checkLocationScope: () => {
        const { request, baseResponse, loading } = useFetchData.Get<CheckLocationScope>({
            projectId: ApiConfig.PROJECT_ID.HRM_SERVICE
        });
        return {
            fetch: (param: { latitude: string; longitude: string; branch_id?: number }) => request({
                endPoint: API_ATTENDANCE_ROUTER.API_ATTENDANCE_CHECK_LOCATION_SCOPE,
                data: param
            }),
            response: baseResponse,
            loading: loading
        };
    },
    checkInStatus: () => {
        const { request, baseResponse, loading } = useFetchData.Get<CheckInStatus>({
            projectId: ApiConfig.PROJECT_ID.HRM_SERVICE
        });
        return {
            fetch: () => request({
                endPoint: API_ATTENDANCE_ROUTER.API_ATTENDANCE_CHECK_IN_STATUS,
            }),
            response: baseResponse,
            loading: loading
        };
    },
    getAttendance: () => {
        const { request, baseResponse, loading } = useFetchData.Get<any[]>({
            projectId: ApiConfig.PROJECT_ID.HRM_SERVICE
        });
        return {
            fetch: (param: {
                month: string; user_id: number;
            }) => request({
                endPoint: API_ATTENDANCE_ROUTER.API_GET_ATTENDANCE,
                data: param
            }),
            response: baseResponse,
            loading: loading
        };
    },
    getAttendanceDaily: () => {
        const { request, baseResponse, loading } = useFetchData.Get<BasePaginateResponse<any[]>>({
            projectId: ApiConfig.PROJECT_ID.HRM_SERVICE
        });
        return {
            fetch: (param: {
                page: number; limit: number;
                date: string; key_search: string;
                branch_id?: number;
            }) => request({
                endPoint: API_ATTENDANCE_ROUTER.API_GET_ATTENDANCE_DAILY,
                data: param
            }),
            response: baseResponse,
            loading: loading
        };
    },
    getAttendanceGrid: () => {
        const { request, baseResponse, loading } = useFetchData.Get<BasePaginateResponse<AttendanceGridRow[]>>({
            projectId: ApiConfig.PROJECT_ID.HRM_SERVICE
        });
        return {
            fetch: (param: {
                page: number; limit: number;
                from_date?: string; to_date?: string;
                month?: string; key_search?: string;
                branch_id?: number;
                attendance_modes?: string;
            }) => request({
                endPoint: API_ATTENDANCE_ROUTER.API_GET_ATTENDANCE_GRID,
                data: param
            }),
            response: baseResponse,
            loading: loading
        };
    },
    getAttendanceGridExport: () => {
        const { request, baseResponse, loading } = useFetchData.Get<AttendanceGridRow[]>({
            projectId: ApiConfig.PROJECT_ID.HRM_SERVICE
        });
        return {
            fetch: (param: {
                from_date?: string; to_date?: string;
                month?: string; key_search?: string;
                branch_id?: number;
                attendance_modes?: string;
            }) => request({
                endPoint: API_ATTENDANCE_ROUTER.API_GET_ATTENDANCE_GRID_EXPORT,
                data: param
            }),
            response: baseResponse,
            loading: loading
        };
    },
    approveIssue: () => {
        const { request, baseResponse, loading } = useFetchData.Post({
            projectId: ApiConfig.PROJECT_ID.HRM_SERVICE
        });
        return {
            fetch: (param: {
                employee_id: number; work_date: string;
                issue_type: number; work_day_coefficient: number;
                notes: string
            }) => request({
                endPoint: API_ATTENDANCE_ROUTER.API_GET_ATTENDANCE_APPROVE_ISSUE,
                data: param
            }),
            response: baseResponse,
            loading: loading
        };
    },

    attendanceCheckIn: () => {
        const { request, baseResponse, loading } = useFetchData.Post({
            projectId: ApiConfig.PROJECT_ID.HRM_SERVICE
        });
        return {
            fetch: (body: {
                latitude: string; longitude: string;
                ip?: string; device_id: string;
                avatar?: string; address: string;
            }) => request({
                endPoint: API_ATTENDANCE_ROUTER.API_ATTENDANCE_CHECK_IN,
                data: body
            }),
            response: baseResponse,
            loading: loading
        };
    },
    attendanceCheckOut: () => {
        const { request, baseResponse, loading } = useFetchData.Post({
            projectId: ApiConfig.PROJECT_ID.HRM_SERVICE
        });
        return {
            fetch: (body: {
                latitude: string; longitude: string;
                ip?: string; device_id: string;
                avatar?: string; address: string;
            }) => request({
                endPoint: API_ATTENDANCE_ROUTER.API_ATTENDANCE_CHECK_OUT,
                data: body
            }),
            response: baseResponse,
            loading: loading
        };
    },
    attendanceEmployeeDailySession: () => {
        const { request, baseResponse, loading } = useFetchData.Get<AttendanceDailySession>({
            projectId: ApiConfig.PROJECT_ID.HRM_SERVICE
        });
        return {
            fetch: (body: {
                date: string; employee_id: number;
            }) => request({
                endPoint: API_ATTENDANCE_ROUTER.API_ATTENDANCE_EMPLOYEE_DAILY_SESSIONS,
                data: body
            }),
            response: baseResponse,
            loading: loading
        };
    },
      getAttendanceExcel: () => {
        const { request, baseResponse, loading } = useFetchData.Get<any[]>({
            projectId: ApiConfig.PROJECT_ID.HRM_SERVICE
        });
        return {
            fetch: (param: {
                from_date: string; to_date: string; user_ids: string,department_id:string;
            }) => request({
                endPoint: API_ATTENDANCE_ROUTER.API_GET_ATTENDANCE_EXCEL,
                data: param
            }),
            response: baseResponse,
            loading: loading
        };
    },
}